import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';

interface PublicLegalLinksProps {
  /** Extra class on the wrapper (e.g. for page footer vs form footer). */
  className?: string;
  /** When true, use muted text suited for a page bottom strip. */
  muted?: boolean;
}

/**
 * Compact Privacy / Terms / Contact links for login surfaces and page footers.
 * Prefer this over header nav — legal belongs at the bottom, not competing with primary CTAs.
 */
export const PublicLegalLinks: React.FC<PublicLegalLinksProps> = ({
  className = '',
  muted = false,
}) => {
  const { t } = useLanguage();
  const linkClass = muted
    ? 'text-xs text-[var(--color-tab-inactive-text)] hover:text-[var(--color-primary-text)] transition-colors'
    : 'text-xs text-[var(--color-secondary-text)] hover:text-[var(--color-primary-text)] transition-colors';

  return (
    <nav
      aria-label={t('website.footer.legal') || 'Legal'}
      className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 ${className}`}
    >
      <Link to="/privacy" className={linkClass}>
        {t('website.footer.privacy_policy') || 'Privacy Policy'}
      </Link>
      <span className="text-xs text-[var(--color-border)]" aria-hidden>
        ·
      </span>
      <Link to="/terms" className={linkClass}>
        {t('website.footer.terms_of_service') || 'Terms of Service'}
      </Link>
      <span className="text-xs text-[var(--color-border)]" aria-hidden>
        ·
      </span>
      <a href="mailto:info@t-mos.com" className={linkClass}>
        {t('website.footer.contact') || 'Contact Us'}
      </a>
    </nav>
  );
};
